import { createFileRoute } from "@tanstack/react-router";
import { WireRequests } from "@/components/WireRequests";

function RouteComponent() {
  return <WireRequests />;
}

export const Route = createFileRoute("/_authenticated/wire-requests/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
